module.exports = __webpack_public_path__ + "images/phone-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/phone-icon.png
// module id = 69dP
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15